import { PagerLink } from '@components';

export const InPostPager: React.FC<{
  links: {
    href: string;
    label: string;
    isCurrent?: boolean;
  }[];
}> = ({ links }) => (
  <div className='flex justify-center gap-2'>
    {links.map((l) => (
      <PagerLink key={l.href} href={l.href} isCurrent={l.isCurrent}>
        {l.label}
      </PagerLink>
    ))}
  </div>
);
